import { Link as RouterLink } from "react-router-dom";
import * as React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" component={RouterLink} to="/" onMouseOver={(e) => (e.target.style.color = "#4183c5")} onMouseOut={(e) => (e.target.style.color = "inherit")}>
        ZamZam
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
